<template>
  <a-modal
    title="新建模板"
    style="top: 20px;"
    :width="1300"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit(queryParam)"
    destroyOnClose="true"
    @cancel="handleClose"
  >
    <div v-if="imgState" @click="cancelImg" style="width: 100%;height: 100%;background-color: rgba(225,225,225,0.5) ">
      <div style="position: fixed;z-index: 9999;left: 0;right: 0;top:0;bottom:0;margin: auto;width: 500px;height: 50%">
        <img :src="imgs" style="width: 100%;height: auto" />
      </div>
    </div>
    <a-form :form="form">
      <a-card
        type="inner"
        style="width:100%;display: flex;justify-content: center"
        headStyle="background:white;border:none"
        :bordered="false"
        :tabList="tabListNoTitle"
        @tabChange="key => handleTabChange(key, 'noTitleKey')"
      >
      </a-card>
      <a-row style="padding: 0 30px" :class="status == 1 ? 'readyOnly' : ''">
        <a-col :span="24" style="padding: 12px 12px">
          <a-form-item label="订单类型" style="display: flex;justify-content: center;align-items: center;margin: 0px">
            <a-radio-group v-decorator="['orderType']" @change="changeType">
              <a-radio v-for="type in List" :value="type.orderTypeId">
                {{ type.typeName }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item label="模板名称" style="display: flex;justify-content: center;align-items: center;margin: 0px">
            <a-input v-model="queryParam.modelName" :disabled="saveApproval" />
          </a-form-item>
        </a-col>
      </a-row>
      <div style="margin-bottom: 8px" :class="status == 1 ? 'readyOnly' : ''">
        <span style="font-weight: bold">销单资料</span>
        <a-button class="twobtn" style="margin: 0 10px" type="primary" @click="addsaleList">添加</a-button>
        <a-button type="primary" @click="listSave">保存</a-button>
      </div>
      <a-table
        size="default"
        ref="table"
        showHeader="false"
        :data-source="saleList"
        :columns="columns"
        bordered
        :class="status == 1 ? 'readyOnly' : ''"
      >
        <span slot="saleInfoName" slot-scope="text, record">
          <a-input :defaultValue="record.saleInfoName" v-model="record.saleInfoName" />
        </span>
        <span slot="examplePicUrl" slot-scope="text, record">
          <div v-if="record.examplePicUrl" class="upload-list-inline-item">
            <img :src="record.examplePicUrl" alt="example" />
            <div class="upload-list-inline-item-actions">
              <a-icon type="eye" @click="handlePreview(record.examplePicUrl)" />
              <a-icon type="delete" @click="handleDeleteExamplePic(record)" />
            </div>
          </div>
          <a-upload
            v-else
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="uploadUrlb"
            :headers="headers"
            :before-upload="beforeUpload"
            @change="handleSaleImgChange($event, record)"
          >
            <div>
              <a-icon :type="record.loading ? 'loading' : 'plus'" />
              <div class="ant-upload-text">上传</div>
            </div>
          </a-upload>
        </span>
        <span slot="picMaxCount" slot-scope="text, record">
          <a-input-number :min="record.picMinCount" :defaultValue="record.picMaxCount" v-model="record.picMaxCount" />
        </span>
        <span slot="picMinCount" slot-scope="text, record">
          <a-input-number :defaultValue="record.picMinCount" v-model="record.picMinCount" />
        </span>
        <span slot="videoMaxCount" slot-scope="text, record">
          <a-input-number :defaultValue="record.videoMaxCount" v-model="record.videoMaxCount" />
        </span>
        <span slot="videoMinCount" slot-scope="text, record">
          <a-input-number :defaultValue="record.videoMinCount" v-model="record.videoMinCount" />
        </span>
        <span slot="remark" slot-scope="text, record">
          <a-input :defaultValue="record.remark" :maxLength="50" v-model="record.remark" />
        </span>
        <span slot="action" slot-scope="text, record, index">
          <a-icon type="minus-square" style="font-size: 25px" @click="delsaleList(index)" v-if="index > 2" />
        </span>
      </a-table>
      <div style="width: 100%;height: 2px;background-color: black"></div>
      <a-row :class="status == 1 ? 'readyOnly' : ''">
        <a-col :span="2" style="display: flex;justify-content: center;flex-direction: column;">
          <span style="font-weight: bold;line-height: 30px">核销内容</span>
          <a-button class="twobtn" type="primary" @click="danxuan">单选</a-button>
          <a-button class="twobtn" type="primary" @click="duoxuan">多选</a-button>
          <a-button class="twobtn" type="primary" @click="xiala">下拉框</a-button>
          <a-button class="twobtn" type="primary" @click="wenben">单项填空</a-button>
        </a-col>
        <a-col :span="22" style="border: 1px solid #c7c7c7;margin-top: 30px">
          <div v-for="(item, number) in subjectList" :key="item.sort">
            <div
              style="display: flex;width: 100%;border-bottom: 0.5px solid #c7c7c7;margin-bottom: 0px;border-top: 0.5px solid #c7c7c7;"
            >
              <a-form-item
                style="width: 50%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                v-if="item.subjectType == 0"
              >
                <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                ><br />
                <a-radio-group style="width: 50%;display: flex;flex-direction: column">
                  <a-radio
                    :style="radioStyle"
                    v-for="type in item.subjectOptionList"
                    :key="type.optionSort"
                    :value="type.optionSort"
                  >
                    <span style="width: 100%;display: inline-block;text-align: left">
                      {{ type.optionName }}
                      <a-input
                        size="small"
                        v-if="type.isDescription == 1"
                        v-model="type.wenben"
                        style="display: inline-block;width: 200px;height: 30px;"
                      />
                      <span
                        v-if="type.isRequiredDescription == 1 && type.isDescription == 1"
                        style="color: red;margin-left: 10px;font-weight: bold"
                        >*</span
                      >
                    </span>
                  </a-radio>
                </a-radio-group>
              </a-form-item>

              <a-form-item
                style="width: 50%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                v-if="item.subjectType == 1"
              >
                <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                ><br />
                <a-checkbox-group style="width: 50%;display: flex;flex-direction: column">
                  <a-checkbox
                    style="margin-left:0px"
                    v-for="type in item.subjectOptionList"
                    :key="type.optionSort"
                    :value="type.optionSort"
                  >
                    <span>{{ type.optionName }}</span>
                    <a-input
                      size="small"
                      v-if="type.isDescription == 1"
                      v-model="type.wenben"
                      style="width: 200px;height: 30px;"
                    />
                    <span
                      v-if="type.isRequiredDescription == 1 && type.isDescription == 1"
                      style="color: red;margin-left: 10px;font-weight: bold"
                      >*</span
                    >
                  </a-checkbox>
                </a-checkbox-group>
              </a-form-item>

              <a-form-item
                style="width: 50%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column;text-align: left"
                v-if="item.subjectType == 2"
              >
                <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                ><br />
                <a-select style="width:  50%" @change="handleChange">
                  <a-select-option
                    value=""
                    v-for="type in item.subjectOptionList"
                    :key="type.optionSort"
                    :value="type.optionSort"
                  >
                    <span style="width: 60%;display: inline-block">
                      {{ type.optionName }}
                      <a-input
                        size="small"
                        v-if="type.isDescription == 1"
                        v-model="type.wenben"
                        style="display: inline-block;width: 200px;height: 30px;"
                      />
                      <span
                        v-if="type.isRequiredDescription == 1 && type.isDescription == 1"
                        style="color: red;margin-left: 10px;font-weight: bold"
                        >*</span
                      >
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item
                style="width: 50%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                v-if="item.subjectType == 3"
              >
                <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                ><br />
                <a-input disabled="true" size="small" style="display: inline-block;width: 200px;height: 30px" />
              </a-form-item>

              <a-form-item
                style="width: 50%;padding: 0px 0px 0px 8px;display: flex;flex-direction: column"
                v-if="item.subjectType == 4"
              >
                <span style="width: 100%">{{ number + 1 + '、' + item.subjectName }}</span
                ><br />
                <a-rate v-model="value" />
              </a-form-item>
              <!--工具栏工具栏工具栏工具栏工具栏工具栏工具栏工具栏工具栏-->
              <div style="width: 50%;display: flex;align-items: center" v-if="number > 5 || addState">
                <span @click="editState(number)"
                  ><a-button class="twobtn" type="primary" icon="form">编辑</a-button></span
                >
                <span @click="delState(number)" style="margin: 0 5px"
                  ><a-button type="danger" icon="delete">删除</a-button></span
                >
                <span @click="upState(number)"
                  ><a-button type="primary" class="twobtn" icon="arrow-up">上移</a-button></span
                >
                <span @click="downState(number)" style="margin: 0 5px"
                  ><a-button type="primary" class="twobtn" icon="arrow-down">下移</a-button></span
                >
                <span @click="uptopState(number)"
                  ><a-button type="primary" icon="vertical-align-top" class="twobtn">最前</a-button></span
                >
                <span @click="downbottomState(number)" style="margin: 0 5px"
                  ><a-button type="primary" icon="vertical-align-bottom" class="twobtn">最后</a-button></span
                >
              </div>
            </div>
            <div v-if="item.edtion == '1'">
              <div v-if="item.subjectType == 4" style="padding-bottom: 20px">
                <span
                  style="display: block;clear: both;margin-left: 70px;line-height: 26px;margin-top: 20px;margin-bottom: 20px"
                >
                  <a-checkbox @change="needReply(4, number)" style="margin: 0 15px">必答</a-checkbox>
                  <a-checkbox @change="onChange">企业是否可见</a-checkbox>
                </span>
                <span style="margin-left: 40px;margin-bottom: 30px"
                  >逻辑设置： <a @click="Edition(number)">题目关联</a></span
                >
                <div
                  v-if="item.visible == 1 ? true : false"
                  style="width: 80%;border: 1px solid #eeeeee;margin: 10px auto"
                >
                  <a-form :form="form">
                    <span
                      style="display: block;width: 100%;height: 30px;line-height: 30px;font-weight: bold;margin-left: 10px"
                      >设置逻辑关联</span
                    >
                    <div style="width: 100%;padding: 0 30px">
                      <a-form-item
                        label="当前题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        {{ number + 1 + '、' + item.subjectName }}
                      </a-form-item>
                      <a-form-item
                        label="关联题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <span
                          v-for="(a, b) in subjectList"
                          :key="b"
                          v-if="item.relationSubjectId == a.sort && item.isRelationSubject != null"
                          >{{ b + 1 + '、' + a.subjectName }}[{{
                            a.subjectType == 0
                              ? '单选'
                              : a.subjectType == 1
                              ? '多选'
                              : a.subjectType == 2
                              ? '下拉框'
                              : '文本框'
                          }}]</span
                        >
                        <a-select v-if="item.isRelationSubject == null">
                          <a-select-option
                            v-for="(a, b) in subjectList"
                            :key="b"
                            v-if="b < number && a.subjectType != 3 && a.subjectType != 4 && a.isRelationSubject != 1"
                            @click="Topicrelevance(a.sort)"
                            >{{ b + 1 + '、' + a.subjectName }}[{{
                              a.subjectType == 0
                                ? '单选'
                                : a.subjectType == 1
                                ? '多选'
                                : a.subjectType == 2
                                ? '下拉框'
                                : '文本框'
                            }}]</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                      <a-form-item
                        label="关联选项"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <a-checkbox-group
                          @change="Topicoptions"
                          v-for="(c, items) in subjectList"
                          v-if="item.isRelationSubject != 1"
                          :key="items"
                        >
                          <a-checkbox
                            v-if="c.sort == optionsIndex && optionsIndex > -1"
                            v-for="i in c.subjectOptionList"
                            :value="i.optionSort"
                            >{{ i.optionName }}</a-checkbox
                          >
                        </a-checkbox-group>

                        <a-checkbox-group
                          @change="Topicoptions"
                          v-model="subjectRelationList[number].optionIds + ''"
                          v-for="(j, labei) in subjectList"
                          v-if="j.sort == item.relationSubjectId && item.isRelationSubject == 1"
                          :key="labei"
                        >
                          <a-checkbox v-for="z in j.subjectOptionList" :value="z.optionSort">{{
                            z.optionName
                          }}</a-checkbox>
                        </a-checkbox-group>
                      </a-form-item>
                      <span>
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px;margin-left: 10px"
                          v-if="item.isRelationSubject == 1"
                          @click="updateTopic(number, item.sort)"
                          >解除关联</a-button
                        >
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px"
                          v-else
                          @click="confirmTopic(optionSort, optionsIndex, item.sort, number)"
                          >确认关联</a-button
                        >
                      </span>
                    </div>
                  </a-form>
                </div>
              </div>

              <div v-if="item.subjectType == 3" style="padding-bottom: 20px">
                <span
                  style="display: block;clear: both;margin-left: 70px;line-height: 26px;margin-top: 20px;margin-bottom: 20px"
                >
                  <a-checkbox @change="onChanged(number)" style="margin: 0 15px">限制范围</a-checkbox>
                  <span>
                    <span>最小字数：</span
                    ><a-input-number
                      v-model="item.minLength"
                      :disabled="item.disable"
                      style="display: inline-block;width: 100px;height: 30px"
                    />
                  </span>
                  <span>
                    <span>最大字数：</span
                    ><a-input-number
                      v-model="item.maxLength"
                      :disabled="item.disable"
                      style="display: inline-block;width: 100px;height: 30px"
                    />
                  </span>
                  <br />

                  <a-checkbox @change="needReply(4, number)" style="margin: 0 15px">必答</a-checkbox>
                  <a-checkbox @change="onChange">企业是否可见</a-checkbox>
                </span>
                <span style="margin-left: 40px;margin-bottom: 30px"
                  >逻辑设置： <a @click="Edition(number)">题目关联</a></span
                >
                <div
                  v-if="item.visible == 1 ? true : false"
                  style="width: 80%;border: 1px solid #eeeeee;margin: 10px auto"
                >
                  <a-form :form="form">
                    <span
                      style="display: block;width: 100%;height: 30px;line-height: 30px;font-weight: bold;margin-left: 10px"
                      >设置逻辑关联</span
                    >
                    <div style="width: 100%;padding: 0 30px">
                      <a-form-item
                        label="当前题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        {{ number + 1 + '、' + item.subjectName }}
                      </a-form-item>
                      <a-form-item
                        label="关联题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <span
                          v-for="(a, b) in subjectList"
                          :key="b"
                          v-if="item.relationSubjectId == a.sort && item.isRelationSubject != null"
                          >{{ b + 1 + '、' + a.subjectName }}[{{
                            a.subjectType == 0
                              ? '单选'
                              : a.subjectType == 1
                              ? '多选'
                              : a.subjectType == 2
                              ? '下拉框'
                              : '文本框'
                          }}]</span
                        >
                        <a-select v-if="item.isRelationSubject == null">
                          <a-select-option
                            v-for="(a, b) in subjectList"
                            :key="b"
                            v-if="b < number && a.subjectType != 3 && a.subjectType != 4 && a.isRelationSubject != 1"
                            @click="Topicrelevance(a.sort)"
                            >{{ b + 1 + '、' + a.subjectName }}[{{
                              a.subjectType == 0
                                ? '单选'
                                : a.subjectType == 1
                                ? '多选'
                                : a.subjectType == 2
                                ? '下拉框'
                                : '文本框'
                            }}]</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                      <a-form-item
                        label="关联选项"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <a-checkbox-group
                          @change="Topicoptions"
                          v-for="(c, items) in subjectList"
                          v-if="item.isRelationSubject != 1"
                          :key="items"
                        >
                          <a-checkbox
                            v-if="c.sort == optionsIndex && optionsIndex > -1"
                            v-for="i in c.subjectOptionList"
                            :value="i.optionSort"
                            >{{ i.optionName }}</a-checkbox
                          >
                        </a-checkbox-group>

                        <a-checkbox-group
                          @change="Topicoptions"
                          v-model="subjectRelationList[number].optionIds + ''"
                          v-for="(j, labei) in subjectList"
                          v-if="j.sort == item.relationSubjectId && item.isRelationSubject == 1"
                          :key="labei"
                        >
                          <a-checkbox v-for="z in j.subjectOptionList" :value="z.optionSort">{{
                            z.optionName
                          }}</a-checkbox>
                        </a-checkbox-group>
                      </a-form-item>
                      <span>
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px;margin-left: 10px"
                          v-if="item.isRelationSubject == 1"
                          @click="updateTopic(number, item.sort)"
                          >解除关联</a-button
                        >
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px"
                          v-else
                          @click="confirmTopic(optionSort, optionsIndex, item.sort, number)"
                          >确认关联</a-button
                        >
                      </span>
                    </div>
                  </a-form>
                </div>
                <div @click="FinallyState(number)" style="width: 100%;display: flex">
                  <a-button class="twobtn" type="primary" v-if="number > 5 || addState" style="margin: 0 auto"
                    >完成编辑</a-button
                  >
                </div>
              </div>

              <div v-if="item.subjectType < 3" style="padding-bottom: 20px">
                <div>
                  <span
                    style="display: inline-block;width: 100px;text-align: left;line-height: 30px;padding-left: 30px;margin-top: 25px"
                    >标题</span
                  >
                  <a-input
                    size="small"
                    v-model="item.subjectName"
                    style="display: inline-block;width: 200px;height: 30px"
                  />
                  <span style="width: 250px;display:inline-block;margin-left: 100px">
                    <span>扣分类型：</span>
                    <a-select style="width: 150px" v-model="item.penaltyType" allowClear="true">
                      <a-select-option value="3">配合度</a-select-option>
                      <a-select-option value="4">服务规范</a-select-option>
                      <a-select-option value="5">安全规范</a-select-option>
                      <!--                    <a-select-option  v-for="type in shifuList"  :key="type.key" :value="type.key">{{type.label}}</a-select-option>-->
                    </a-select>
                  </span>
                </div>
                <span style="width: 100px;text-align: left;line-height: 30px;padding-left: 30px;float: left"
                  >选项文字</span
                >
                <span style="float: left">
                  <span style="display: block" v-for="(type, index) in item.subjectOptionList" :key="type.optionSort">
                    <a-input
                      size="small"
                      v-model="type.optionName"
                      style="display: inline-block;width: 290px;height: 30px"
                    />
                    <span style="display: inline-block;margin-left: 10px"
                      >扣分值
                      <a-input-number :min="1" :max="100" style="width: 70px;" v-model="type.penaltyValue" />
                    </span>
                    <a-icon
                      style="font-size: 26px;margin-left: 10px;position: relative;top:2px;left: 0;"
                      type="minus-square"
                      @click="reducechoose(index, number, item.subjectType)"
                    /> </span
                ></span>
                <span style="float: right;width: 50%;height: 90px;position: relative;top:-30px;">
                  <span style="height: 30px;width: 100%;line-height: 30px;text-align: center">
                    <a-row style="width: 100%">
                      <a-col :span="4"></a-col>
                      <a-col :span="3">图片</a-col>
                      <a-col :span="8">说明</a-col>
                      <a-col :span="3">允许填空</a-col>
                      <a-col :span="6">允许填空去除</a-col>
                    </a-row>
                  </span>
                  <span
                    style="height: 30px;width: 100%;"
                    v-for="(type, index) in item.subjectOptionList"
                    :key="type.optionName"
                  >
                    <a-row
                      style="width: 100%;line-height: 30px;text-align: center;overflow-y: hidden;height: 30px;margin-top: 3px"
                    >
                      <a-col :span="4"></a-col>
                      <a-col :span="3" @click="dianji(index, number, item.subjectType)">
                        <a-upload
                          :data-index="index"
                          :action="uploadUrlb"
                          :multiple="true"
                          :fileList="fileList"
                          :headers="headers"
                          @preview="handlePreview"
                          @change="handleChange"
                          v-if="type.picUrl == '' && type.optionSort == index"
                          :before-upload="beforeUpload"
                        >
                          <a-icon
                            style="font-size: 26px;position: relative;top:2px;left: 0;"
                            type="file-image"
                            v-if="type.picUrl == ''"
                          />
                        </a-upload>
                        <!--<a-modal :footer="null" @cancel="handleCancel">-->
                        <img
                          v-if="type.show && type.picUrl !== ''"
                          style="width: 30px;height: 30px"
                          :src="type.picUrl"
                          @click="fangda(type.picUrl)"
                        />
                        <!--</a-modal>-->
                      </a-col>
                      <a-col :span="8">
                        <a-input
                          v-model="type.optionText"
                          style="height: 30px;text-align: center"
                          v-if="type.textshow || type.optionText"
                        />
                        <a-icon
                          style="font-size: 26px;position: relative;top:2px;left: 0;"
                          type="file-text"
                          @click="inputText(index, number)"
                          v-else
                        />
                      </a-col>
                      <a-col :span="3">
                        <a-checkbox
                          @change="onChangeoptions(index, number, item.subjectType)"
                          :checked="subjectList[number].subjectOptionList[index].isDescription == 1 ? true : false"
                        ></a-checkbox
                      ></a-col>
                      <a-col :span="6"
                        ><a-checkbox
                          @change="onChangeRequired(index, number, item.subjectType)"
                          :checked="
                            subjectList[number].subjectOptionList[index].isRequiredDescription == 1 ? true : false
                          "
                        ></a-checkbox
                      ></a-col>
                    </a-row>
                  </span>
                </span>
                <span
                  style="display: block;clear: both;margin-left: 70px;line-height: 26px;margin-top: 20px;margin-bottom: 20px"
                >
                  <span style="display: inline-block" @click="addchoose(item.subjectType, number)">
                    <a-icon
                      style="font-size: 26px;margin-left: 10px;position: relative;top:2px"
                      type="plus-square"
                    />添加选项
                  </span>

                  <a-checkbox
                    @change="needReply(item.subjectType, number)"
                    :checked="item.isReply == 1 ? true : false"
                    style="margin: 0 15px"
                    >必答</a-checkbox
                  >
                  <a-checkbox
                    @change="EntVisible(item.subjectType, number)"
                    :checked="item.isEntVisible == 1 ? true : false"
                    >企业是否可见</a-checkbox
                  >
                </span>
                <span style="margin-left: 40px;margin-bottom: 30px"
                  >逻辑设置： <a @click="Edition(number)">题目关联</a></span
                >
                <div
                  v-if="item.visible == 1 ? true : false"
                  style="width: 80%;border: 1px solid #eeeeee;margin: 10px auto"
                >
                  <a-form :form="form">
                    <span
                      style="display: block;width: 100%;height: 30px;line-height: 30px;font-weight: bold;margin-left: 10px"
                      >设置逻辑关联</span
                    >
                    <div style="width: 100%;padding: 0 30px">
                      <a-form-item
                        label="当前题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        {{ number + 1 + '、' + item.subjectName }}
                      </a-form-item>
                      <a-form-item
                        label="关联题目"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <span
                          v-for="(a, b) in subjectList"
                          :key="b"
                          v-if="item.relationSubjectId == a.sort && item.isRelationSubject != null"
                          >{{ b + 1 + '、' + a.subjectName }}[{{
                            a.subjectType == 0
                              ? '单选'
                              : a.subjectType == 1
                              ? '多选'
                              : a.subjectType == 2
                              ? '下拉框'
                              : '文本框'
                          }}]</span
                        >
                        <a-select v-if="item.isRelationSubject == null">
                          <a-select-option
                            v-for="(a, b) in subjectList"
                            :key="b"
                            v-if="b < number && a.subjectType != 3 && a.subjectType != 4 && a.isRelationSubject != 1"
                            @click="Topicrelevance(a.sort)"
                            >{{ b + 1 + '、' + a.subjectName }}[{{
                              a.subjectType == 0
                                ? '单选'
                                : a.subjectType == 1
                                ? '多选'
                                : a.subjectType == 2
                                ? '下拉框'
                                : '文本框'
                            }}]</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                      <a-form-item
                        label="关联选项"
                        :label-col="formItemLayout1.labelCol"
                        :wrapper-col="formItemLayout1.wrapperCol"
                        style="margin: 0px"
                      >
                        <a-checkbox-group
                          @change="Topicoptions"
                          v-for="(c, items) in subjectList"
                          v-if="item.isRelationSubject != 1"
                          :key="items"
                        >
                          <a-checkbox
                            v-if="c.sort == optionsIndex && optionsIndex > -1"
                            v-for="i in c.subjectOptionList"
                            :value="i.optionSort"
                            >{{ i.optionName }}</a-checkbox
                          >
                        </a-checkbox-group>

                        <a-checkbox-group
                          @change="Topicoptions"
                          v-model="subjectRelationList[number].optionIds + ''"
                          v-for="(j, labei) in subjectList"
                          v-if="j.sort == item.relationSubjectId && item.isRelationSubject == 1"
                          :key="labei"
                        >
                          <a-checkbox v-for="z in j.subjectOptionList" :value="z.optionSort">{{
                            z.optionName
                          }}</a-checkbox>
                        </a-checkbox-group>
                      </a-form-item>
                      <span>
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px;margin-left: 10px"
                          v-if="item.isRelationSubject == 1"
                          @click="updateTopic(number, item.sort)"
                          >解除关联</a-button
                        >
                        <a-button
                          class="twobtn"
                          style="margin-bottom: 10px"
                          v-else
                          @click="confirmTopic(optionSort, optionsIndex, item.sort, number)"
                          >确认关联</a-button
                        >
                      </span>
                    </div>
                  </a-form>
                </div>
                <div @click="FinallyState(number)" style="width: 100%;display: flex">
                  <a-button class="twobtn" v-if="number > 5 || addState" type="primary" style="margin: 0 auto"
                    >完成编辑</a-button
                  >
                </div>
              </div>
            </div>
          </div>
        </a-col>
        <a-col :span="24" style="display: flex;justify-content: center;align-content: center;margin: 30px 0px">
          <a-button class="twobtn" type="primary" v-if="saveApproval" @click="addModel(queryParam)">保存资料</a-button>
        </a-col>
      </a-row>
    </a-form>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </a-modal>
</template>

<script>
import {
  addEntModel,
  getEntModelDetail,
  saveApprovalSaleOrder,
  editEntModel
} from '@/api/enterprise/enterpriseCustomization'
import { getList } from '@/api/order/orderList'
import { getDictMap } from '@/utils/dict'
import { customerModelAdd, selectSubjectByModelId } from '@/api/enterprise/customerModel'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  data() {
    return {
      // 查询参数
      value1: '123',
      optionSort: [],
      queryParam: {
        // orderType:'',
        modelName: ''
      },
      visible1: false,
      visible: false,
      tabListNoTitle: [],
      restaurantOperTypeMap: [],
      noTitleKey: 'app',
      form: this.$form.createForm(this),
      List: [],
      // 表头
      columns: [
        {
          title: '状态',
          dataIndex: 'saleInfoName',
          scopedSlots: { customRender: 'saleInfoName' },
          align: 'center'
        },
        {
          title: '图片最大值',

          dataIndex: 'picMaxCount',
          scopedSlots: { customRender: 'picMaxCount' },
          align: 'center'
        },
        {
          title: '图片必传值',
          dataIndex: 'picMinCount',
          scopedSlots: { customRender: 'picMinCount' },
          align: 'center'
        },
        {
          title: '视频最大值',
          dataIndex: 'videoMaxCount',
          scopedSlots: { customRender: 'videoMaxCount' },
          align: 'center'
        },
        {
          title: '视频必传值',
          dataIndex: 'videoMinCount',
          scopedSlots: { customRender: 'videoMinCount' },
          align: 'center'
        },
        {
          title: '示例图',
          dataIndex: 'examplePicUrl',
          scopedSlots: { customRender: 'examplePicUrl' },
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          scopedSlots: { customRender: 'remark' }
        },
        {
          title: '删减',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        }
      ],
      saleList: [
        {
          picMaxCount: 3, // 图片最大数量
          picMinCount: 1, // 图片必传值
          examplePicUrl: '', // 示例图
          loading: false, // loading
          saleInfoName: '施工前', // 销单资料名称
          videoMaxCount: 0, // 视频最大值
          videoMinCount: 0, // 视频必传值
          remark: '' // 备注
        },
        {
          picMaxCount: 3, // 图片最大数量
          picMinCount: 1, // 图片必传值
          examplePicUrl: '', // 示例图
          loading: false, // loading
          saleInfoName: '施工中', // 销单资料名称
          videoMaxCount: 0, // 视频最大值
          videoMinCount: 0, // 视频必传值
          remark: '' // 备注
        },
        {
          picMaxCount: 3, // 图片最大数量
          picMinCount: 1, // 图片必传值
          examplePicUrl: '', // 示例图
          saleInfoName: '施工后', // 销单资料名称
          videoMaxCount: 0, // 视频最大值
          videoMinCount: 0, // 视频必传值
          remark: '' // 备注
        }
      ],
      subjectList: [],
      // 上传1
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=basicdatas',
      fileList: [],
      fileListTitle: [],

      Index: 0,
      Index2: 0,
      danxuanNo: [],
      timuNo: 6,
      guanxiNo: '',
      timuNo2: 0,
      timuNo3: 0,
      timuNo4: 0,
      danxuanState: [],

      duoxuanNo: [],
      state: 0,
      xialaNo: [],
      wenbenNo: [],
      stateTwo: '',
      Index3: '',
      status: 0,
      formItemLayout1: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 2 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 }
        }
      },
      optionsIndex: -1, // 关联题目的序号
      subjectRelationList: [],
      saveApproval: false,
      enterpriseModelId: '',
      cState: '',
      imgState: false,
      addState: true,
      imgs: '',
      previewVisible: false,
      previewImage: '',
      shifuList: [
        { label: '配合度', key: 3 },
        { label: '服务规范', key: 4 },
        { label: '安全规范', key: 5 }
      ]
      // addEnable: checkPermission('enterprise:districtPriceDistrict:add'),
      // editEnabel: checkPermission('enterprise:districtPriceDistrict:edit'),
      // removeEnable: checkPermission('enterprise:districtPriceDistrict:remove')
    }
  },
  async created() {
    // 字典为安装类型
    this.tabListNoTitle = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      this.tabListNoTitle.push({ key: key, tab: value })
    })
    getList(this.tabListNoTitle[0].key).then(res => {
      if (res.code == 0) {
        this.List = res.rows
        console.log(res.rows)
        this.value1 = this.List[0].orderTypeId
        // this.queryParam.orderType=this.List[0].orderTypeId
      } else {
        this.$message.error(res.msg)
      }
    })
    this.queryParam.installType = this.tabListNoTitle[0].key
    console.log(this.queryParam)
  },
  watch: {
    // timuNo(val){
    //   if(this.addState){
    //     for(var i=0;i<this.timuNo-6;i++){
    //       this.subjectRelationList[i]= {
    //         optionIds: [],
    //         relationSubjectId: '',
    //         subjectId: ''
    //       }
    //     }
    //   }else{
    //     for(var i=0;i<this.timuNo;i++){
    //       this.subjectRelationList[i]= {
    //         optionIds: [],
    //         relationSubjectId: '',
    //         subjectId: ''
    //       }
    //     }
    //   }
    //
    // }
  },
  methods: {
    fangda(img) {
      this.imgState = true
      this.imgs = img
    },
    cancelImg() {
      this.imgState = false
    },
    // 切换订单类型
    changeType(e) {
      console.log(this.List, 'this.List')
      console.log(e.target.value)
      this.subjectRelationList = []
      if (this.addState) {
      } else {
        getEntModelDetail({ modelId: this.enterpriseModelId, orderType: e.target.value }).then(res => {
          console.log('销单资料', res)
          if (res.code == 0) {
            // if (res.data.code == 0) {
            //   this.$message.error('该订单类型下无题目')
            // }
            this.queryParam.modelName = res.data.modelName
            this.subjectList = res.data.subjectList
            this.timuNo = res.data.subjectList.length
            for (var i = 0; i < this.subjectList.length; i++) {
              if (this.subjectList[i].relationSubjectId == null) {
              } else {
                this.subjectList[i].visible = 1
                this.subjectRelationList.push({
                  optionIds: this.subjectList[i].optionList,
                  relationSubjectId: this.subjectList[i].relationSubjectId,
                  subjectId: this.subjectList[i].sort
                })
              }
            }
            this.saleList = res.data.saleList.map(item => ({ ...item, examplePicUrl: item.examplePicUrl || '', loading: false }))
            console.log('编辑模板关联关系' + this.subjectRelationList)

            for (var i = 0; i < this.subjectList.length; i++) {
              this.subjectList[i].edtion = '0'
            }
            this.saveApproval = true
          } else {
            this.$message.error('该订单类型下无题目')
          }
        })
      }
    },
    // 修改关联关系
    updateTopic(number, sort) {
      console.log(this.subjectRelationList)
      console.log(sort)
      for (var i = 0; i < this.subjectRelationList.length; i++) {
        // this.subjectRelationList.splice(sort-1,1)
        this.subjectRelationList[number] = {
          optionIds: [],
          relationSubjectId: '',
          subjectId: ''
        }
      }
      console.log(this.subjectRelationList)
      this.subjectList[number].isRelationSubject = null
      this.subjectList[number].relationSubjectId = null
    },
    // 保存销单资料
    addModel(data) {
      console.log(data)
      // if(data.orderType==undefined || data.orderType==''){
      //   this.$message.error('请点击选择订单类型')
      // }
      if (data.modelName == undefined) {
        this.$message.error('请填写模板名称')
      } else {
        var allData = {}
        allData.entModelId = this.enterpriseModelId
        allData.modelName = data.modelName
        allData.installType = data.installType
        allData.orderType = orderType
        allData.subjectList = this.subjectList
        allData.subjectRelationList = this.subjectRelationList
        saveApprovalSaleOrder(allData).then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('保存核销资料成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },

    Topicrelevance(b) {
      console.log(b)
      this.optionsIndex = b
      console.log(this.optionsIndex)
    },
    Topicoptions(e) {
      ;``
      console.log(e)
      this.optionSort = e
    },
    confirmTopic(a, b, c, d) {
      console.log(a, b, c, d)
      this.cState = c

      console.log(this.subjectList)
      if (a.length > 0 && b !== -1 && c) {
        for (var z = 0; z < this.subjectList.length; z++) {
          this.subjectRelationList[d] = {
            optionIds: a.map(String),
            relationSubjectId: b,
            subjectId: c
          }
          if (this.subjectList[z].sort == c) {
            this.subjectList[z].isRelationSubject = 1
            this.subjectList[z].relationSubjectId = b
            console.log(this.subjectList[z].isRelationSubject)
          }
        }

        console.log(this.subjectRelationList)

        this.$message.success('关联成功')
      } else {
        this.$message.error('关联失败')
      }
    },
    Edition(number) {
      console.log('设置题目关联')
      if (number == 0) {
        this.$message.error('第一题无法设置关联逻辑')
      } else {
        if (this.subjectList[number].visible == 0) {
          this.subjectList[number].visible = 1
        } else {
          this.subjectList[number].visible = 0
        }
      }
    },
    addsaleList() {
      this.saleList.push({
        picMaxCount: 3, // 图片最大数量
        picMinCount: 1, // 图片必传值
        examplePicUrl: '', // 示例图
        saleInfoName: '', // 销单资料名称
        videoMaxCount: 0, // 视频最大值
        videoMinCount: 0, // 视频必传值
        remark: '' // 备注
      })
    },
    handleTabChange(e) {
      // this.queryParam.orderType=''
      console.log(e)
      this.queryParam.installType = e
      this.List = []
      getList(e).then(res => {
        if (res.code === 0) {
          this.List = res.rows
          console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
      this.form.setFieldsValue({ orderType: undefined })
    },
    delsaleList(e) {
      this.saleList.splice(e, 1)
    },
    // 新建
    add() {
      getList(this.tabListNoTitle[0].key).then(res => {
        if (res.code === 0) {
          this.queryParam = {}
          this.subjectList = []
          this.visible = true
          this.saveApproval = false
          this.enterpriseModelId = ''
          this.saleList = [
            {
              picMaxCount: 3, // 图片最大数量
              picMinCount: 1, // 图片必传值
              examplePicUrl: '', // 示例图
              saleInfoName: '安装前', // 销单资料名称
              videoMaxCount: 0, // 视频最大值
              videoMinCount: 0, // 视频必传值
              remark: '' // 备注
            },
            {
              picMaxCount: 3, // 图片最大数量
              picMinCount: 1, // 图片必传值
              examplePicUrl: '', // 示例图
              loading: false, // loading
              saleInfoName: '安装中', // 销单资料名称
              videoMaxCount: 0, // 视频最大值
              videoMinCount: 0, // 视频必传值
              remark: '' // 备注
            },
            {
              picMaxCount: 3, // 图片最大数量
              picMinCount: 1, // 图片必传值
              examplePicUrl: '', // 示例图
              saleInfoName: '安装后', // 销单资料名称
              videoMaxCount: 0, // 视频最大值
              videoMinCount: 0, // 视频必传值
              remark: '' // 备注
            }
          ]
          this.subjectRelationList = []
          this.addState = true
          this.timuNo = 6
          this.List = res.rows
          console.log(res.rows[0].orderTypeId)
          this.value1 = res.rows[0].orderTypeId
          this.form.setFieldsValue({
            orderType: res.rows[0].orderTypeId
          })
          this.$nextTick(() => {
            this.form.setFieldsValue({ orderType: this.value1 })
            console.log(this.form.getFieldValue('orderType'))
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 编辑
    edit(record, status) {
      this.status = status
      // console.log('编辑的status', status)
      // console.log(this.value1)
      console.log(record)
      this.addState = false
      this.subjectRelationList = []
      this.mdl = Object.assign(record)
      this.enterpriseModelId = record.enterpriseModelId
      console.log(this.enterpriseModelId)
      this.visible = true
      // this.$nextTick(() => {
      //   this.form.setFieldsValue(pick(this.mdl, 'channelId', 'enterpriseId', 'installType','channelName','enterpriseName'))
      // })
      getEntModelDetail({ modelId: record.enterpriseModelId, orderType: this.List[0].orderTypeId }).then(res => {
        console.log(res.data.subjectList, 'data.subjectListdata.subjectListdata.subjectList')
        if (res.code == 0) {
          this.queryParam.modelName = res.data.modelName
          this.subjectList = res.data.subjectList
          this.timuNo = res.data.subjectList.length
          for (var i = 0; i < this.subjectList.length; i++) {
            if (this.subjectList[i].relationSubjectId == null) {
            } else {
              this.subjectList[i].visible = 1
            }

            // for(var j=0;j<this.subjectRelationList.length;j++){
            //   this.subjectRelationList[j].optionIds=this.subjectList[i].optionList==null?[]:this.subjectList[i].optionList
            //   this.subjectRelationList[j].relationSubjectId=this.subjectList[i].relationSubjectId
            //   this.subjectRelationList[j].subjectId=this.subjectList[i].sort
            // }
            this.subjectRelationList.push({
              optionIds: this.subjectList[i].optionList,
              relationSubjectId: this.subjectList[i].relationSubjectId,
              subjectId: this.subjectList[i].sort
            })
          }
          console.log(this.subjectRelationList)
          this.saleList = res.data.saleList.map(item => ({ ...item, examplePicUrl: item.examplePicUrl || '', loading: false }))
          console.log('编辑模板关联关系' + this.subjectRelationList)

          for (var i = 0; i < this.subjectList.length; i++) {
            this.subjectList[i].edtion = '0'
          }

          this.saveApproval = true
        }
      })
      this.$nextTick(() => {
        this.handleTabChange(this.tabListNoTitle[0].key)
        this.form.setFieldsValue({ orderType: this.value1 })
        console.log(this.form.getFieldValue('orderType'))
      })
    },
    listSave() {
      this.handleSubmit(this.queryParam, 1)
    },
    handleSubmit(data, key) {
      const orderType = this.form.getFieldValue('orderType')
      console.log(orderType)
      // if(data.orderType==undefined || data.orderType==''){
      //   this.$message.error('请点击选择订单类型')
      // }
      if (data.modelName == undefined) {
        this.$message.error('请填写模板名称')
      } else if (orderType == undefined) {
        this.$message.error('请选择订单类型')
      } else if (this.subjectList.length == 0) {
        this.$message.error('请选择核销内容')
      } else {
        var that = this
        if (key != 1) {
          this.confirmLoading = true
        }
        if (that.enterpriseModelId == '') {
          var allData = {}
          allData.modelName = data.modelName
          allData.installType = data.installType
          allData.orderType = orderType
          allData.saleList = that.saleList
          allData.subjectList = that.subjectList
          allData.subjectRelationList = that.subjectRelationList
          console.log(allData)
          addEntModel(allData).then(res => {
            console.log(res)
            if (res.code == 0) {
              that.confirmLoading = false
              that.visible = false
              that.$emit('ok')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          console.log(that.enterpriseModelId)
          var allData2 = {}
          allData2.orderType = orderType
          allData2.installType = data.installType
          allData2.modelId = that.enterpriseModelId
          allData2.subjectList = that.subjectList
          allData2.subjectRelationList = that.subjectRelationList
          for (let i = 0; i < that.saleList.length; i++) {
            that.saleList[i]['installType'] = data.installType
            that.saleList[i]['orderType'] = orderType
          }
          allData2.sale = that.saleList
          console.log(allData2.sale)
          editEntModel(allData2).then(res => {
            console.log(res)
            if (res.code == 0 && key != 1) {
              that.visible = false
              that.confirmLoading = false
              that.$emit('ok')
            } else {
              this.$message.success('保存成功')
            }
          })
        }
      }
    },
    handleClose() {
      this.status = ''
      this.$emit('ok')
    },
    // 添加模板编辑
    editState(number) {
      console.log(this.subjectList)
      console.log(this.subjectList[number])
      console.log(this.subjectList[number].edtion)
      for (var i = 0; i < this.subjectList.length; i++) {
        this.subjectList[i].edtion = '0'
      }
      this.subjectList[number].edtion = '1'
    },
    FinallyState(number) {
      this.subjectList[number].edtion = '0'
    },
    // 删除该题型
    delState(number) {
      console.log(number)
      var sort = this.subjectList[number].sort
      for (var i = 0; i < this.subjectList.length; i++) {
        this.subjectList[i].sort--
        if (this.subjectList[i].sort < number) {
          this.subjectList[i].sort++
        }
        console.log(this.subjectList[i].sort)
      }
      this.subjectList.splice(number, 1)
      console.log(this.subjectList)
      this.timuNo--
      console.log(this.subjectRelationList)
    },
    // 数组元素互换位置
    swapArray(arr, index1, index2) {
      var sort1 = arr[index1].sort
      var sort2 = arr[index2].sort
      arr[index1].sort = sort2
      arr[index2].sort = sort1
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]

      console.log(arr)
      return arr
    },
    // 上移一步
    upState(number) {
      console.log(number)
      console.log(this.subjectRelationList, 'this.subjectRelationList')

      for (var i = 0; i < this.subjectRelationList.length; i++) {
        if (this.subjectRelationList[i].optionIds != null) {
          if (this.subjectRelationList[i].optionIds.length > 0) {
            this.$message.error('已设置题目关联关系，无法移动')
            return false
          }
        }
      }

      if (this.addState) {
        if (number == 0) {
          this.$message.error('已经是第一题，无法上移')
        } else {
          this.swapArray(this.subjectList, number - 1, number)
        }
      } else {
        if (number == 6) {
          this.$message.error('已经是第一题，无法上移')
        } else {
          this.swapArray(this.subjectList, number - 1, number)
        }
      }
    },
    // 下移一步
    downState(number) {
      for (var i = 0; i < this.subjectRelationList.length; i++) {
        if (this.subjectRelationList[i].optionIds != null) {
          if (this.subjectRelationList[i].optionIds.length > 0) {
            this.$message.error('已设置题目关联关系，无法移动')
            return false
          }
        }
      }

      if (number == this.subjectList.length - 1) {
        this.$message.error('已经是最后一题，无法下移')
      } else {
        this.swapArray(this.subjectList, number, number + 1)
      }
    },
    // 上移到顶部
    uptopState(number) {
      for (var i = 0; i < this.subjectRelationList.length; i++) {
        if (this.subjectRelationList[i].optionIds.length > 0) {
          this.$message.error('已设置题目关联关系，无法移动')
          return false
        }
      }
      console.log(number)
      if (this.addState) {
        if (number == 0) {
          this.$message.error('已经是最前，无法上移')
        } else {
          var sort1 = this.subjectList[0].sort
          this.subjectList[number].sort = sort1 - 1
          for (var i = 0; i < this.subjectList.length; i++) {
            this.subjectList[i].sort++
            if (this.subjectList[i].sort > number + 1) {
              this.subjectList[i].sort--
            }
            console.log(this.subjectList[i].sort)
          }

          this.subjectList.unshift(this.subjectList[number])
          this.subjectList.splice(number + 1, 1)
          console.log(this.subjectList)
        }
      } else {
        if (number == 6) {
          this.$message.error('已经是最前，无法上移')
        } else {
          console.log(this.subjectList)
          this.swapArray(this.subjectList, 6, number)
        }
      }
    },
    // 下移到最后
    downbottomState(number) {
      for (var i = 0; i < this.subjectRelationList.length; i++) {
        if (this.subjectRelationList[i].optionIds.length > 0) {
          this.$message.error('已设置题目关联关系，无法移动')
          return false
        }
      }
      if (number == this.subjectList.length - 1) {
        this.$message.error('已经是最后，无法下移')
      } else {
        var max = this.subjectList.length
        var sort1 = this.subjectList[max - 1].sort
        this.subjectList[number].sort = sort1 + 1
        for (var i = 0; i < this.subjectList.length; i++) {
          this.subjectList[i].sort--
          if (this.subjectList[i].sort < number) {
            this.subjectList[i].sort++
          }
          console.log(this.subjectList[i].sort)
        }
        var array = this.subjectList[number]
        this.subjectList.splice(number, 1)
        this.subjectList.push(array)
        console.log(this.subjectList)
      }
    },
    // 点击添加选项
    addchoose(state, number) {
      const index = this.subjectList[number].subjectOptionList.length
      this.subjectList[number].subjectOptionList.push({
        optionName: '',
        optionSort: index,
        picUrl: '',
        show: false,
        optionDescription: '',
        textshow: false,
        isDescription: 0,
        isRequiredDescription: 0
      })
    },
    // 点击减少当前选项
    reducechoose(index, number, state) {
      console.log(index, number, state)
      this.subjectList[number].subjectOptionList.splice(index, 1)
    },
    handleDeleteExamplePic(record) {
      this.$set(record, 'examplePicUrl', '')
    },
    handlePreview(url) {
      this.previewImage = url
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    handleSaleImgChange(info, record) {
      if (info.file.status === 'uploading') {
        this.$set(record, 'loading', true)
        return
      }
      if (info.file.status === 'done') {
        this.$set(record, 'loading', false)
        if (info.file.response.code == 0) {
          const url = process.env.VUE_APP_API_BASE_URL +
            '/dfs/download?fileName=' +
            info.file.response.url +
            '&token=' +
            Vue.ls.get(ACCESS_TOKEN)
          // Ensure reactivity
          this.$set(record, 'examplePicUrl', url)
          this.$message.success(`${info.file.name}上传成功`);
        } else {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      } else if (info.file.status === 'error') {
        this.$set(record, 'loading', false)
        this.$message.error(`${info.file.name} 上传失败.`);
      }
    },
    handleChange({ fileList }) {
      console.log(fileList)
      console.log(this.Index2, this.Index)
      this.fileList = fileList
      this.subjectList[this.Index2].subjectOptionList[this.Index].picUrl =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        fileList[0].response.url +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      this.subjectList[this.Index2].subjectOptionList[this.Index].show = true
      this.fileList = ''
    },
    // handleChangeTitle({fileList}) {
    //   console.log(fileList)
    //   this.fileListTitle = fileList;
    //   this.subjectList[this.Index3].pictureList[0].picUrl = fileList[0].response.url
    //   this.subjectList[this.Index3].picUrlstate= true
    //   this.fileListTitle = '';
    // },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('请上传JPG、PNG格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('图片大小不能超过5MB!')
      }
      return isJpgOrPng && isLt2M
    },
    dianji(index, number, state) {
      console.log(index)
      this.Index = index
      this.Index2 = number
      this.state = state
    },
    titlepic(number, state) {
      this.stateTwo = state
      this.Index3 = number
    },
    inputText(index, number) {
      console.log(index, number)
      this.subjectList[number].subjectOptionList[index].textshow = true
      console.log(this.subjectList[number].subjectOptionList[index].textshow)
    },
    needReply(state, number) {
      if (this.subjectList[number].isReply == 0) {
        this.subjectList[number].isReply = 1
      } else {
        this.subjectList[number].isReply = 0
      }
    },
    EntVisible(state, number) {
      if (this.subjectList[number].isEntVisible == 0) {
        this.subjectList[number].isEntVisible = 1
      } else {
        this.subjectList[number].isEntVisible = 0
      }
    },

    onChangeoptions(index, number) {
      if (this.subjectList[number].subjectOptionList[index].isDescription == 0) {
        this.subjectList[number].subjectOptionList[index].isDescription = 1
      } else {
        this.subjectList[number].subjectOptionList[index].isDescription = 0
      }
    },
    onChangeRequired(index, number) {
      if (this.subjectList[number].subjectOptionList[index].isRequiredDescription == 0) {
        this.subjectList[number].subjectOptionList[index].isRequiredDescription = 1
      } else {
        this.subjectList[number].subjectOptionList[index].isRequiredDescription = 0
      }
    },
    danxuan() {
      this.form.getFieldValue('orderType')
      console.log(this.form.getFieldValue('orderType'))
      this.timuNo++
      this.subjectRelationList.push({ optionIds: [], relationSubjectId: '', subjectId: '' })
      console.log(this.subjectRelationList)
      this.subjectList.push({
        subjectOptionList: [
          {
            optionName: '是',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          },
          {
            optionName: '否',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        isReply: 0,
        subjectType: '0',
        edtion: '0',
        visible: 0,
        isEntVisible: 0,
        penaltyType: '',
        relationSubjectId: null,
        orderType: this.form.getFieldValue('orderType'),
        isRelationSubject: null
      })
    },
    duoxuan() {
      this.timuNo++
      console.log(this.subjectRelationList)
      this.subjectRelationList.push({ optionIds: [], relationSubjectId: '', subjectId: '' })
      this.subjectList.push({
        subjectOptionList: [
          {
            optionName: '选项1',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          },
          {
            optionName: '选项2',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        isReply: 0,
        subjectType: '1',
        edtion: '0',
        visible: 0,
        isEntVisible: 0,
        penaltyType: '',
        relationSubjectId: null,
        orderType: this.form.getFieldValue('orderType'),
        isRelationSubject: null
      })
    },
    xiala() {
      this.timuNo++
      this.subjectRelationList.push({ optionIds: [], relationSubjectId: '', subjectId: '' })
      console.log(this.subjectRelationList)
      this.subjectList.push({
        subjectOptionList: [
          {
            optionName: '选项1',
            optionSort: '0',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          },
          {
            optionName: '选项2',
            optionSort: '1',
            picUrl: '',
            show: false,
            optionText: '',
            textshow: false,
            isDescription: 0,
            wenben: '',
            isRequiredDescription: 0,
            penaltyValue: ''
          }
        ],
        sort: this.timuNo,
        subjectName: '标题',
        picUrl: '',
        isReply: 0,
        subjectType: '2',
        edtion: '0',
        visible: 0,
        isEntVisible: 0,
        penaltyType: '',
        relationSubjectId: null,
        orderType: this.form.getFieldValue('orderType'),
        isRelationSubject: null
      })
    },
    wenben() {
      this.timuNo++
      this.subjectRelationList.push({ optionIds: [], relationSubjectId: '', subjectId: '' })
      console.log(this.subjectRelationList)
      this.subjectList.push({
        sort: this.timuNo,
        subjectName: '标题',
        disable: true,
        minLength: '0',
        maxLength: '100',
        picUrl: '',
        isReply: 0,
        subjectType: '3',
        edtion: '0',
        visible: 0,
        isEntVisible: 0,
        penaltyType: '',
        relationSubjectId: null,
        orderType: this.form.getFieldValue('orderType'),
        isRelationSubject: null
      })
    },
    onChanged(number) {
      if (this.subjectList[number].disable == false) {
        this.subjectList[number].disable = true
        this.subjectList[number].min = 0
        this.subjectList[number].max = 100
      } else {
        this.subjectList[number].disable = false
      }
    }
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 4px 16px !important;
}
.twobtn {
  width: 90px;
  font-size: 15px;
  margin: 2px 0;
}
.readyOnly {
  pointer-events: none;
}
.upload-list-inline-item {
  position: relative;
  width: 104px;
  height: 104px;
  margin: 0 auto;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px;
  overflow: hidden;
}
.upload-list-inline-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upload-list-inline-item-actions {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 10;
}
.upload-list-inline-item:hover .upload-list-inline-item-actions {
  opacity: 1;
}
.upload-list-inline-item-actions .anticon {
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  margin: 0 8px;
}

</style>
